/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';
import { __UNSAFE_SPACE_TO_DIMSUM, op, styled, withTheme } from '@elliemae/ds-system';

const Header = styled(Grid)`
  height: 100%;
  background: ${(props) => props.theme.colors.brand['600']};
  padding: ${(props) => __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xxs)};
`;

const DSMobilePageSearch = withTheme(
  ({
    HeaderContainer = Header,
    SearchContainer = Header,
    searchHeader = null,
    pageTitle = 'Search',
    body = null,
    theme,
  }) => {
    const rows = [
      op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.l), 0.81),
      op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.l), 1.62),
      1,
    ];
    return (
      <Grid rows={rows} height="100%">
        <Grid>
          <HeaderContainer>{pageTitle}</HeaderContainer>
        </Grid>
        <Grid>
          <SearchContainer>{searchHeader}</SearchContainer>
        </Grid>
        <Grid height="100%" style={{ overflow: 'hidden' }}>
          <Grid height="100%" style={{ overflow: 'auto' }}>
            {body}
          </Grid>
        </Grid>
      </Grid>
    );
  },
);

const DSPageSearch = DSMobilePageSearch;

export { DSMobilePageSearch, DSPageSearch };
